import axios from "axios";

import URLS from "../../util/urls";

const state = {
  listaContratosVencidos: []
};

const mutations = {
  atualizarListaContratosVencidos(state, payload) {
    state.listaContratosVencidos = payload;
  },

  limparContratos() {
    state.listaContratosVencidos = [];
  },
};

const actions = {
  recuperarContratosVencidos(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_CONTRATOS_VENCIDOS).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarContratosVencidos');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return context.commit('atualizarListaContratosVencidos', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
};

export default {
  state,
  mutations,
  actions
};